export default __webpack_public_path__ + "img/4e0bb55048ad9a30206546e09a7fad84.png";